var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "playground_alt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#b97d6d;} .st1{fill:#454545;}  "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.855,242.5c-63.411,0-115-51.589-115-115s51.589-115,115-115c63.411,0,115,51.589,115,115 S189.268,242.5,125.855,242.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.854,30.758c-53.619,0-97.241,43.623-97.241,97.243c0,53.619,43.623,97.241,97.241,97.241 c53.621,0,97.244-43.622,97.244-97.241C223.098,74.381,179.475,30.758,125.854,30.758z M117.167,81.5 c10.31,0,18.667,6.119,18.667,13.667s-8.357,13.667-18.667,13.667S98.5,102.715,98.5,95.167S106.857,81.5,117.167,81.5z M91.456,61.969l7.175,15.4c-2.222,1.642-4.147,3.588-5.708,5.763c-8.319-0.667-17.745-0.764-26.896,0.563 C72.727,74.667,81.426,67.216,91.456,61.969z M125.854,202.482c-19.532,0-37.323-7.568-50.62-19.912 c5.268-21.813,18.013-47.752,32.933-64.404c2.664,0.753,5.056,1.167,8,1.167c0.38,0,7.291-0.819,7.667-0.833l44.667,73 C160.501,200.833,132.939,202.482,125.854,202.482z M141.559,85.7c-0.638-1.173-1.379-2.293-2.207-3.355 c6.272-6.702,14.479-14.065,23.662-18.855c15.776,9.123,27.911,23.854,33.656,41.46C179.616,94.565,160.953,88.031,141.559,85.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.f6a91637c81200ec112650d9247b0217.svg";
export { ForwardRef as ReactComponent };